import { observable, action, runInAction } from 'mobx';
import { get, jsonPost, post } from '../../utils/fetch';
import { errorHandler } from '../../utils/methods';
import { backendServerInvestor } from '../../variable';

class MyProjectStore {
  @observable
  projectObj = {
    total: 0,
    list: []
  };
  @observable
  legalInstrumentObj = {
    investmentAgreement: '',
    page: {
      list: [],
      total: 0
    }
  };
  @observable
  projectDetail = {
    contractPlantFiles: [],
    contractPlantLegalInstruments: [],
    contractPlantProjectDetailDto: {},
    contractPlantRawMaterials: []
  };
  @observable
  purchaseInfo = {};
  @observable
  materialObj = {
    inverterObj: {
      num: 0,
      rawMaterialNumDtoList: []
    },
    assemblyObj: {
      num: 0,
      rawMaterialNumDtoList: []
    },
    collectorObj: {
      rawMaterialNumDtoList: []
    }
  };
  @observable
  enterpriseList = [];
  @observable
  stationPicObj = {
    status: '',
    stationInstallObj: {},
    fieldConstructionObj: {}
  };
  @observable
  netRecordInfo = {
    inverterAccountDtoList: [],
    plantName: '',
    contractPlantFileDtoList: []
  };
  @observable
  payConfirmation = {
    list: []
  };
  @observable
  purchaseFile = '';
  @observable
  profitUserList = []; //收益用户列表

  @observable
  maintenanceArrangementList = []; //维修安排列表
  @observable
  maintenanceRecordList = []; //维修记录列表

  //维修安排列表
  @action
  getArrangementList = async params => {
    let result;
    try {
      result = await get(`${backendServerInvestor}/web/maintain`, params);
      runInAction(() => {
        console.log('维修安排列表', result);
        if (result.success) {
          this.maintenanceArrangementList =
            result.data && (result.data.list || []);
        }
      });
    } catch (err) {
      return errorHandler(err, '维修安排列表');
    }
    return result;
  };
  //维修记录列表
  @action
  getRecordList = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/maintain/record`,
        params
      );
      runInAction(() => {
        console.log('维修记录列表', result);
        if (result.success) {
          this.maintenanceRecordList = result.data && (result.data.list || []);
        }
      });
    } catch (err) {
      return errorHandler(err, '维修安排列表');
    }
    return result;
  };
  //增加维修安排
  addArrangement = async (params = {}) => {
    let result;
    try {
      result = await post(`${backendServerInvestor}/web/maintain/add`, params);
      runInAction(() => {
        console.log('增加一条维修安排', result);
        if (result.success) {
        }
      });
    } catch (err) {
      return errorHandler(err, '维修安排列表');
    }
    return result;
  };
  //增加维修记录
  arrRepairRecord = async (params = {}) => {
    let result;
    try {
      result = await post(
        `${backendServerInvestor}/web/maintain/record/add`,
        params
      );
      runInAction(() => {
        console.log('增加一条维修记录', result);
        if (result.success) {
        }
      });
    } catch (err) {
      return errorHandler(err, '维修安排列表');
    }
    return result;
  };

  /**
   * 代理商发布项目
   * @param {projectId} 需要发布的项目标识
   * @returns {Response} 发布的结果
   */
  agentPublishProject = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/product/publish`,
        params
      );
    } catch (err) {
      return errorHandler(err, '代理商发布项目接口');
    }
    return result;
  };

  // 项目列表
  @action
  fetchProjectList = async params => {
    let result;
    try {
      result = await get(`${backendServerInvestor}/web/project`, params);
      runInAction(() => {
        if (result.success) {
          this.projectObj = result.data;
        } else {
          this.projectObj = {
            total: 0,
            list: []
          };
        }
      });
    } catch (err) {
      return errorHandler(err, '查询项目列表');
    }
    return result;
  };

  // 删除项目
  @action
  fetchDeleteProject = async params => {
    let result;
    try {
      result = await get(`${backendServerInvestor}/web/project/delete`, params);
    } catch (err) {
      return errorHandler(err, '删除项目');
    }
    return result;
  };

  // 项目详情
  @action
  fetchProjectDetail = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/project/${params.projectId}`
      );
      runInAction(() => {
        if (result.success) {
          this.projectDetail = result.data;
        }
      });
    } catch (err) {
      return errorHandler(err, '项目详情');
    }
    return result;
  };

  // 检测项目名称是否重复
  @action
  fetchCheckProjectName = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/project/validate`,
        params
      );
    } catch (err) {
      return errorHandler(err, '项目名重复');
    }
    return result;
  };

  // 获取代理商所有企业列表
  @action
  fetchEnterpriseList = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/enterprise/listAll`,
        params
      );
      runInAction(() => {
        if (result.success) {
          this.enterpriseList = result.data;
        }
      });
    } catch (err) {
      return errorHandler(err, '代理商所有企业列表');
    }
    return result;
  };

  // 新建项目
  @action
  fetchNewProject = async params => {
    let result;
    try {
      result = await jsonPost(
        `${backendServerInvestor}/web/project/create`,
        params
      );
    } catch (err) {
      return errorHandler(err, '新建项目');
    }
    return result;
  };

  // 获取法律文件
  @action
  fetchLegalDocumentFile = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/project/legalFile`,
        params
      );
    } catch (err) {
      return errorHandler(err, '查看法律文件');
    }
    return result;
  };

  // 获取申购信息---项目进度
  @action
  fetchPurchaseInfo = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/process/purchase`,
        params
      );
      runInAction(() => {
        if (result.success) {
          this.purchaseInfo = result.data;
        }
      });
    } catch (err) {
      return errorHandler(err, '查询项目列表');
    }
    return result;
  };

  // 确认申购项目---项目进度
  @action
  fetchConfirmPurchase = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/process/purchase/confirm`,
        params
      );
    } catch (err) {
      return errorHandler(err, '申购项目');
    }
    return result;
  };

  // 原材料列表---项目进度
  @action
  fetchMaterialList = async params => {
    let result;
    try {
      result = await get(`${backendServerInvestor}/web/process/buy`, params);
      runInAction(() => {
        if (result.success) {
          const inverterObj = result.data.find(item => item.materialType === 1);
          const assemblyObj = result.data.find(item => item.materialType === 2);
          const collectorObj = result.data.find(
            item => item.materialType === 3
          );
          this.materialObj = {
            inverterObj,
            assemblyObj,
            collectorObj
          };
        }
      });
    } catch (err) {
      return errorHandler(err, '查询项目列表');
    }
    return result;
  };

  // 原材料购买---项目进度
  @action
  fetchMaterialPurchase = async params => {
    let result;
    try {
      result = await jsonPost(
        `${backendServerInvestor}/web/process/buy/confirm`,
        params
      );
    } catch (err) {
      return errorHandler(err, '原材料购买');
    }
    return result;
  };

  // 电站建设---项目进度
  @action
  fetchStationPicList = async params => {
    let result;
    try {
      result = await get(`${backendServerInvestor}/web/process/plant`, params);
      runInAction(() => {
        if (result.success) {
          this.stationPicObj = {
            status: result.data.status,
            stationInstallObj: result.data.stationFiles,
            fieldConstructionObj: result.data.workFiles
          };
        }
      });
    } catch (err) {
      return errorHandler(err, '查询项目列表');
    }
    return result;
  };

  // 确认电站建设---项目进度
  @action
  fetchStationConstruction = async params => {
    let result;
    try {
      result = await jsonPost(
        `${backendServerInvestor}/web/process/plant/confirm`,
        params
      );
    } catch (err) {
      return errorHandler(err, '确认电站建设');
    }
    return result;
  };

  // 并网备案---项目进度
  @action
  fetchNetRecordInfo = async params => {
    let result;
    try {
      result = await get(`${backendServerInvestor}/web/process/record`, params);
      runInAction(() => {
        if (result.success) {
          this.netRecordInfo = result.data;
        }
      });
    } catch (err) {
      return errorHandler(err, '查询项目列表');
    }
    return result;
  };

  // 确认并网备案---项目进度
  @action
  fetchConfirmNetRecord = async params => {
    let result;
    try {
      result = await jsonPost(
        `${backendServerInvestor}/web/process/record/confirm`,
        params
      );
    } catch (err) {
      return errorHandler(err, '并网备案');
    }
    return result;
  };

  // 获取法律文书
  @action
  fetchLegalInstrument = async params => {
    let result;
    try {
      result = await get(`${backendServerInvestor}/web/legal`, params);
      runInAction(() => {
        if (result.success) {
          this.legalInstrumentObj = result.data;
        }
      });
    } catch (err) {
      return errorHandler(err, '查询项目列表');
    }
    return result;
  };

  // 获取打款确认书
  @action
  fetchPayConfirmation = async params => {
    let result;
    try {
      result = await get(`${backendServerInvestor}/web/pay`, params);
      runInAction(() => {
        if (result.success) {
          this.payConfirmation = result.data;
        }
      });
    } catch (err) {
      return errorHandler(err, '获取打款确认书');
    }
    return result;
  };

  // 获取项目投资协议
  @action
  fetchPurchaseFile = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/project/legalFile`,
        params
      );
      runInAction(() => {
        if (result.success) {
          this.purchaseFile = result.data.filePath;
        }
      });
    } catch (err) {
      return errorHandler(err, '获取项目投资协议');
    }
    return result;
  };

  //获取收益用户列表
  @action
  fetchProfitUserList = async params => {
    let result;
    try {
      result = await get(
        `${backendServerInvestor}/web/pay/detail/list`,
        params
      );
      runInAction(() => {
        if (result.success) {
          this.profitUserList = result.data.list;
        }
      });
    } catch (err) {
      return errorHandler(err, '获取收益用户列表');
    }
    return result;
  };
}

const myProjectStore = new MyProjectStore();
export default myProjectStore;



// WEBPACK FOOTER //
// ./src/stores/myProjectStore/index.js